import { render, staticRenderFns } from "./BookClientInformation.vue?vue&type=template&id=09fbb115&"
import script from "./BookClientInformation.vue?vue&type=script&lang=ts&"
export * from "./BookClientInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports